/* src/providers/google-tracking/modals/cookiemodal.scss */
.cookiemodal {
  box-shadow: none;
  width: 95%;
  height: 90%;
}
.cont {
  padding-top: 3%;
}
.foot {
  position: absolute;
  bottom: 5%;
  width: 100%;
}
#col1 {
  text-align: right !important;
}
#col2 {
  text-align: left !important;
}
#b2 {
  --background: white !important;
  --color: var(--primary-color);
  --border-color: var(--primary-color);
  --border-width: 1px;
  --border-style: solid;
}
#h1 {
  font-weight: 900;
  font-size: 1.5rem;
  text-align: center;
  color: black;
}
#p1 {
  color: black;
  font-weight: 600;
  text-align: center;
}
/*# sourceMappingURL=browser/cookiemodal.css.map */
